<template>
  <div>
    <side-bar
      :active-color="sidebarBackground"
      :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor"
    >
      <user-menu></user-menu>
      <!--<mobile-menu></mobile-menu>-->
      <template slot="links">
        <sidebar-item
          :link="{
            name: $t('dashboard.sidebar.dashboard'),
            icon: 'dashboard'
          }"
        >
          <!--          <sidebar-item
            :link="{
              name: $t('dashboard.sidebar.dashboard'),
              path: localePath('dashboard-old'),
              prefix: 'Old dashboard'
            }"
          ></sidebar-item>-->
          <sidebar-item
            v-if="getMyCurrentCenter"
            :link="{
              name: $t('dashboard.sidebar.progress_activity_title'),
              path: localePath('dashboard-activity'),
              prefix: 'Activity'
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="getMyCurrentCenter"
            :link="{
              name: $t('dashboard.sidebar.progress_seo_global'),
              path: localePath('dashboard-seo-global'),
              prefix: 'Activity'
            }"
          ></sidebar-item>
          <!--          <sidebar-item
            :link="{
              name: $t('dashboard.sidebar.progress_title'),
              path: localePath('dashboard-profile'),
              prefix: 'Profile'
            }"
          ></sidebar-item>-->
          <!--          <sidebar-item
            :link="{
              name: $t('dashboard.next_courses'),
              path: localePath('dashboard-coming_courses'),
              prefix: 'SEO'
            }"
          ></sidebar-item>-->
          <!--          <sidebar-item
            :link="{
              name: $t('dashboard.sidebar.progress_seo_title'),
              path: localePath('dashboard-seo'),
              prefix: 'SEO'
            }"
          ></sidebar-item>-->
          <!--          <sidebar-item
            :link="{
              name: $t('dashboard.sidebar.progress_customer_title'),
              path: localePath('dashboard-customer')
            }"
          ></sidebar-item>-->
          <!--          <sidebar-item
            :link="{
              name: $t('dashboard.sidebar.progress_seo_goyoga'),
              path: localePath('dashboard-goyoga'),
              prefix: 'GY'
            }"
          ></sidebar-item>-->
          <!--          <sidebar-item
            :link="{
              name: $t('dashboard.sidebar.progress_seo_gotherapy'),
              path: localePath('dashboard-gotherapy'),
              prefix: 'GT'
            }"
          ></sidebar-item>-->
          <!--          <sidebar-item
            :link="{
              name: $t('dashboard.sidebar.progress_seo_gopilates'),
              path: localePath('dashboard-gopilates'),
              prefix: 'GP'
            }"
          ></sidebar-item>-->
        </sidebar-item>
        <sidebar-item
          v-if="getMyCurrentCenter"
          :link="{
            name: $t('sidebar.community.title'),
            icon: 'people'
          }"
        >
          <sidebar-item
            :link="{
              name: $t('sidebar.account.my_teacher'),
              path: localePath('account-teacher'),
              prefix: 'Teacher'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('sidebar.center.team'),
              path: localePath('center-team'),
              prefix: 'teams'
            }"
          ></sidebar-item>
          <!--          <sidebar-item
            :link="{
              name: $t('sidebar.center.student'),
              path: localePath('account-students'),
              prefix: 'students'
            }"
          ></sidebar-item>-->
          <sidebar-item
            :link="{
              name: $t('sidebar.center.place'),
              path: localePath('center-places'),
              prefix: 'places'
            }"
          ></sidebar-item>
          <!--          <sidebar-item
            :link="{
              name: $t('sidebar.affiliation.title'),
              path: localePath('account-invite'),
              prefix: 'invite'
            }"
          ></sidebar-item>-->
        </sidebar-item>
        <sidebar-item
          v-if="getMyCurrentCenter"
          :link="{ name: $t('sidebar.center.activities'), icon: 'date_range' }"
        >
          <!--          <sidebar-item
            :link="{
              name: $t('sidebar.center.diary'),
              path: localePath('activity-diary'),
              prefix: 'planning'
            }"
          ></sidebar-item>-->
          <sidebar-item
            :link="{
              name: $t('sidebar.center.service'),
              path: localePath('activity-services'),
              prefix: 'services'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('sidebar.center.sessions_to_come'),
              path: localePath('activity-sessions-to-come'),
              prefix: 'sessions'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('sidebar.center.sessions_history'),
              path: localePath('activity-sessions-history'),
              prefix: 'sessions'
            }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          v-if="getMyCurrentCenter"
          :link="{
            name: $t('sidebar.center.finances'),
            icon: 'euro'
          }"
        >
          <!--          <sidebar-item
            :link="{
              name: $t('sidebar.center.subscription'),
              path: localePath('finance-subscriptions'),
              prefix: 'subscriptions'
            }"
          ></sidebar-item>-->
          <sidebar-item
            :link="{
              name: $t('sidebar.center.ewallet'),
              path: localePath('finance-ewallet'),
              prefix: 'ewallet'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('sidebar.center.cash_desk'),
              path: localePath('finance-desk'),
              prefix: 'cash_desk'
            }"
          ></sidebar-item>
          <!--          <sidebar-item
            :link="{
              name: $t('sidebar.account.rib_iban'),
              path: localePath('finance-iban'),
              prefix: 'iban'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('sidebar.center.settings'),
              path: localePath('finance-settings'),
              prefix: 'settings'
            }"
          ></sidebar-item>-->
        </sidebar-item>
        <sidebar-item
          v-if="getMyCurrentCenter"
          :link="{ name: $t('sidebar.marketing.title'), icon: 'timeline' }"
        >
          <sidebar-item
            :link="{
              name: $t('sidebar.website.title'),
              path: localePath('marketing-my_site'),
              prefix: 'my-site'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('sidebar.blog.title'),
              path: localePath('marketing-my_blog'),
              prefix: 'my-blog'
            }"
          ></sidebar-item>
        </sidebar-item>
      </template>
    </side-bar>
  </div>
</template>

<script>
import Vuex from 'vuex'
import UserMenu from '@/components/admin/layout/Extra/UserMenu.vue'
// import MobileMenu from '@/components/creativeTim/dashboardPro/pages/Dashboard/Layout/Extra/MobileMenu'

export default {
  components: {
    UserMenu
    //    MobileMenu
  },
  data() {
    return {
      sidebarBackgroundColor: 'black',
      sidebarBackground: 'green',
      sidebarBackgroundImage: require('@/static/img/sidebar-1.jpg'),
      countCenters:
        this.$auth && this.$auth.user && this.$auth.user.countCenters
          ? this.$auth.user.countCenters
          : 0,
      currentCenter: null,
      // TODO: Add a link to confirm email
      email_verified: !!(
        this.$auth &&
        this.$auth.user &&
        this.$auth.user.confirmationDate
      )
    }
  },
  computed: {
    ...Vuex.mapGetters('center', [
      //      'getMyCenters',
      'getMyCurrentCenter'
      //      'getCenterToken'
    ])
  },
  beforeMount() {},
  mounted() {}
}
</script>
